import React, { useState, useContext } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EditIcon from '@mui/icons-material/Edit';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CircleIcon from '@mui/icons-material/Circle';
import CancelIcon from '@mui/icons-material/Cancel';
import { LOCALES } from '../../i18n';
import { AppContext } from '../context';
import TextField from '@mui/material/TextField';
import ReponseForm from "../forms/ReponseForm";
import OtherForm from "../forms/OtherForm";
import QuestionForm from "../forms/QuestionForm";
import translate from '../../i18n/translate';
import ConfirmModal from '../forms/ConfirmModal';
import { SessionContext } from '../../services/SessionProvider';
import { KeycloackContext } from '../../services/keycloakProvider';
import { getReponseById, updateReponse, cloneReponse, changeTypeReponse } from '../../services/requestHandler';
import { useIntl } from "react-intl";

const default_color = "#8EBF55";
const green = "#307B5B";
const grey = "#b2b2b2";
const yellow = "#ffe436";

export default function CarteQuestion({
  id = "",
  question_id = "",
  reponse_id = "",
  reponse_type = "",
  text_en,
  text,
  arrowFunc = (() => {}),
  needReloadComponent,
  reloadComponent
}) {
  const { state } = useContext(AppContext);
  const {
    addCustomReponse,
    ajoutQuestionCheminForTracking
  } = useContext(SessionContext);
  const { isAdminRole } = useContext(KeycloackContext);

  const [reponseInfos, setReponseInfos] = useState({
    id: "",
    reponse_id: "",
    reponse_type: "",
    contenu: "",
    contenu_en: "",
  });

  const [cardColor, setCardColor] = useState(default_color);
  const [hoverColor, setHoverColor] = useState(green);
  const [createFormOpen, setCreateFormOpen] = useState(false);
  const [otherFormOpen, setOtherFormOpen] = useState(false);
  const [createQuestionFormOpen, setCreateQuestionFormOpen] = useState(false);
  const [reponseText, setReponseText] = useState("");
  const [confirmDuplicateOpen, setConfirmDuplicateOpen] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [customReponse, setCustomReponse] = useState("");
  const [hasToType, setHasToType] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();
  const intl = useIntl();

  React.useEffect(() => {
    setReponseInfos({
      id: id,
      reponse_id: reponse_id,
      reponse_type: reponse_type,
      contenu: text,
      contenu_en: text_en,
    });

    if (reponse_type === "TYPE_3") {
      setCardColor(grey);
      setHoverColor(grey);
    } else if (reponse_type === "TYPE_2") {
      setCardColor(green);
      setHoverColor(green);
    } else if (reponse_type === "TYPE_1") {
      setCardColor(yellow);
      setHoverColor(yellow);
    } else {
      setCardColor(default_color);
      setHoverColor(green);
    }

    if (state.locale === LOCALES.FRENCH) {
      setReponseText(text);
    } else if (state.locale === LOCALES.ENGLISH) {
      setReponseText(text_en);
    }
    // eslint-disable-next-line
  }, [reponse_type, text, text_en, state.locale]);

  async function handleEditReponseClick(newReponseInfos) {
    let tempReponse = await getReponseById(newReponseInfos.reponse_id);
    tempReponse.contenu = newReponseInfos.contenu;
    tempReponse.contenu_en = newReponseInfos.contenu_en;
    await updateReponse(tempReponse);
    needReloadComponent(!reloadComponent);
  }

  async function handleCreateQuestionClick() {
    needReloadComponent(!reloadComponent);
  }

  const handleColorButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let switch_type_body = {
      type_reponse: "",
      id: reponse_id,
    };

    if (e.currentTarget.id === 'greyColorButton') {
      setCardColor(grey);
      setHoverColor(grey);
      switch_type_body.type_reponse = "TYPE_3";
      changeTypeReponse(switch_type_body);
    } else if (e.currentTarget.id === 'greenColorButton') {
      setCardColor(green);
      setHoverColor(green);
      switch_type_body.type_reponse = "TYPE_2";
      changeTypeReponse(switch_type_body);
    } else if (e.currentTarget.id === 'yellowColorButton') {
      setCardColor(yellow);
      setHoverColor(yellow);
      switch_type_body.type_reponse = "TYPE_1";
      changeTypeReponse(switch_type_body);
    } else if (e.currentTarget.id === 'defaultColorButton') {
      setCardColor(default_color);
      setHoverColor(green);
      changeTypeReponse(switch_type_body);
    }
  };

  async function handleDuplicateClick() {
    let tempReponse = await getReponseById(reponse_id);

    const newReponse = {
      new_reponse_parent_id: question_id,
      new_reponse_contenu: tempReponse.contenu,
      new_reponse_contenu_en: tempReponse.contenu_en,
      reponse: tempReponse,
    };

    await cloneReponse(newReponse);
    needReloadComponent(!reloadComponent);
  }

  async function handleDeleteClick() {
    // TODO
  }

  const isReponseCustom = (value) => {
    const customResponses = [
      "[autre]",
      "[other]",
      "Pour faciliter le repérage ultérieur, indiquer vos initiales – celles du patient (p. ex. CV-HC)",
      "To help with later identification, indicate your initials – those of the patient (e.g., CV-HC)",
    ];
    return customResponses.includes(value);
  };

  const isCustomReponseEmpty = (value) => {
    const emptyResponses = [
      null,
      "",
      "[autre]",
      "[other]",
      "Pour faciliter le repérage ultérieur, indiquer vos initiales – celles du patient (p. ex. CV-HC)",
      "To help with later identification, indicate your initials – those of the patient (e.g., CV-HC)",
    ];
    return emptyResponses.includes(value);
  };

  const saveAndNavigate = async () => {
    if (isSubmitting) return;

    try {
      setIsSubmitting(true);

      const questionId = question_id;
      const reponseId = reponse_id;

      if (questionId === undefined || questionId === null || questionId === "") {
        console.error("questionId manquant");
        return;
      }

      if (reponseId === undefined || reponseId === null || reponseId === "") {
        console.error("reponseId manquant");
        return;
      }

      await ajoutQuestionCheminForTracking(reponseId, questionId);
      navigate(`/questionnaire/${reponseId}`);
    } catch (error) {
      console.error("Erreur lors de l'enregistrement de la réponse :", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCardClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isReponseCustom(reponseText)) {
      if (isCustomReponseEmpty(customReponse)) {
        setHasToType(true);
        return;
      }

      addCustomReponse(customReponse, reponse_id);
      await saveAndNavigate();
      return;
    }

    await saveAndNavigate();
  };

  const handleCustomChange = (value) => {
    setCustomReponse(value);
    if (!isCustomReponseEmpty(value)) {
      setHasToType(false);
    }
  };

  const showCustomInput =
    reponseText === "[autre]" ||
    reponseText === "[other]" ||
    reponseText === "Pour faciliter le repérage ultérieur, indiquer vos initiales – celles du patient (p. ex. CV-HC)" ||
    reponseText === "To help with later identification, indicate your initials – those of the patient (e.g., CV-HC)";

  const showSpecialConfirmOnly =
    reponseText === "Vos initiales CV-HC ont été enregistrées. Accédez aux stratégies pour les marquer comme favoris." ||
    reponseText === "Your initials CV-HC have been saved. Go to strategies to mark them as favorite.";

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        onClick={handleCardClick}
        style={{ textDecoration: 'none', cursor: 'pointer' }}
      >
        <Card
          sx={{
            backgroundColor: cardColor,
            minWidth: "90%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            visibility: "visible",
            ':hover': { backgroundColor: hoverColor },
            opacity: isSubmitting ? 0.8 : 1,
          }}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <CardContent style={{ width: "100%" }}>
            <div style={{ display: "flex" }}>
              <div style={{ alignSelf: "center", marginRight: "auto", display: "flex" }}>
                <Typography
                  variant="body2"
                  style={{ fontWeight: "bold", fontSize: "1rem", alignSelf: "center" }}
                >
                  {reponseText}
                </Typography>

                {showSpecialConfirmOnly ? (
                  <div style={{ display: "flex", alignItems: "center", marginLeft: "2rem", gap: "10px" }}>
                    <Button
                      variant="contained"
                      color="success"
                      style={{ height: "40px", alignSelf: "center" }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        navigate("/strategies");
                      }}
                    >
                      Confirmer
                    </Button>
                  </div>
                ) : showCustomInput ? (
                  <div style={{ display: "flex", alignItems: "center", marginLeft: "2rem", gap: "10px" }}>
                    <TextField
                      sx={{
                        input: {
                          color: 'black',
                          fontWeight: 'bold',
                          background: "white"
                        },
                        textDecoration: 'none'
                      }}
                      placeholder={intl.formatMessage({ id: "questionnaire.autrePlaceholder" })}
                      onDrop={(e) => e.preventDefault()}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setOtherFormOpen(true);
                      }}
                      value={customReponse}
                      error={hasToType && isCustomReponseEmpty(customReponse)}
                      onChange={(e) => handleCustomChange(e.target.value)}
                    />
                    <Button
                      variant="contained"
                      color="success"
                      style={{ height: "40px", alignSelf: "center" }}
                      onClick={async (e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        if (!isCustomReponseEmpty(customReponse)) {
                          addCustomReponse(customReponse, reponse_id);
                          await saveAndNavigate();
                        } else {
                          setHasToType(true);
                        }
                      }}
                      disabled={isSubmitting}
                    >
                      {translate("questionnaire.confirmer")}
                    </Button>
                  </div>
                ) : null}
              </div>

              <div style={{ justifyContent: "right", display: "grid" }}>
                <div style={{ justifySelf: "end" }}>
                  {isAdminRole && (
                    <>
                      <IconButton
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setConfirmDuplicateOpen(true);
                        }}
                        aria-label="ContentCopy"
                      >
                        <ContentCopyIcon sx={{ color: "black" }} />
                      </IconButton>

                      <IconButton
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setCreateFormOpen(true);
                        }}
                        aria-label="Edit"
                      >
                        <EditIcon sx={{ color: "black" }} />
                      </IconButton>

                      <IconButton
                        id={`up_${reponse_id}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          arrowFunc(e);
                        }}
                        aria-label="ArrowUpward"
                      >
                        <ArrowUpwardIcon sx={{ color: "black" }} />
                      </IconButton>

                      <IconButton
                        id={`down_${reponse_id}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          arrowFunc(e);
                        }}
                        aria-label="ArrowDownward"
                      >
                        <ArrowDownwardIcon sx={{ color: "black" }} />
                      </IconButton>
                    </>
                  )}
                </div>

                <div style={{ justifySelf: "end" }}>
                  {isAdminRole && (
                    <>
                      <IconButton id="greyColorButton" onClick={handleColorButtonClick} aria-label="CircleGrey">
                        <CircleIcon sx={{ color: grey }} />
                      </IconButton>
                      <IconButton id="greenColorButton" onClick={handleColorButtonClick} aria-label="CircleGreen">
                        <CircleIcon sx={{ color: green }} />
                      </IconButton>
                      <IconButton id="yellowColorButton" onClick={handleColorButtonClick} aria-label="CircleYellow">
                        <CircleIcon sx={{ color: yellow }} />
                      </IconButton>
                      <IconButton id="defaultColorButton" onClick={handleColorButtonClick} aria-label="Cancel">
                        <CancelIcon sx={{ color: "black" }} />
                      </IconButton>
                    </>
                  )}
                </div>
              </div>

              <div style={{ alignSelf: "center" }}>
                <Chip label={id} sx={{ backgroundColor: "white", fontWeight: "bold" }} />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {createFormOpen && (
        <ReponseForm
          reponse={reponseInfos}
          open={createFormOpen}
          setOpen={setCreateFormOpen}
          onConfirm={handleEditReponseClick}
          title={"Edit reponse"}
          description={"Veuillez remplir les cases suivantes pour editer la reponse"}
        />
      )}

      {otherFormOpen && (
        <OtherForm
          value={customReponse}
          open={otherFormOpen}
          setOpen={setOtherFormOpen}
          onConfirm={handleCustomChange}
          title={translate("questionnaire.autreTitle")}
          description={translate("questionnaire.autreDescription")}
        />
      )}

      {createQuestionFormOpen && (
        <QuestionForm
          open={createQuestionFormOpen}
          setOpen={setCreateQuestionFormOpen}
          onConfirm={handleCreateQuestionClick}
          title={"Vous devez creer la question"}
          description={"Veuillez remplir les cases suivantes pour creer la question"}
        />
      )}

      {confirmDuplicateOpen && (
        <ConfirmModal
          content={translate("questionnaire.dupliquer_element")}
          open={confirmDuplicateOpen}
          setOpen={setConfirmDuplicateOpen}
          onConfirm={handleDuplicateClick}
        />
      )}

      {confirmDeleteOpen && (
        <ConfirmModal
          content={translate("questionnaire.supprimer_element")}
          open={confirmDeleteOpen}
          setOpen={setConfirmDeleteOpen}
          onConfirm={handleDeleteClick}
        />
      )}
    </div>
  );
}
